export default {
  isEmail(email) {
    const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return !!pattern.test(email)
  },

  isName(name) {
    const pattern = /^([a-zA-Z ]){2,30}$/
    return !!pattern.test(name.trim())
  },

  isEmpty(value) {
    return value && value.trim().length > 0
  },

  isRequired(value) {
    return !!value
  }
}
